import { render, staticRenderFns } from "./language-control.vue?vue&type=template&id=75da5f08&"
import script from "./language-control.vue?vue&type=script&lang=js&"
export * from "./language-control.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports